import React, { useRef, useEffect, type ReactNode } from 'react';
// eslint-disable-next-line jira/import/no-restricted-paths
import { useOnGadgetRender } from '../../../controllers/above-the-fold';

import { Content, Wrapper } from './styled';

export type GadgetFallbackProps = {
	icon: ReactNode;
	id: string;
	height?: string;
	action?: ReactNode;
	children: ReactNode;
};

export const GadgetFallback = ({ icon, action, id, height, children }: GadgetFallbackProps) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const onGadgetRender = useOnGadgetRender(id);

	useEffect(() => {
		const measuredHeight = ref.current?.getBoundingClientRect().height;
		onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
	}, [onGadgetRender]);

	return (
		<Wrapper height={height} ref={ref}>
			{icon}
			<Content>{children}</Content>
			{action}
		</Wrapper>
	);
};
